import { ChangeEvent, FormEvent } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../store";
import InputWrapper from "../../StylesWrappers/General/inputBox";
import InputBox from "../General/InputBox";
import TextArea from "../General/textArea";
import SelectOption from "../General/SelectOption";
import ButtonWrapper from "../../StylesWrappers/General/button";
import Button from "../General/Button";
import Overlay from "../General/overlay";
import Loader from "../General/Loader";

interface PostJobCompProps {
  handleChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  handleSelect: (e: ChangeEvent<HTMLSelectElement>) => void;
  handleReset: () => void;
  handleSubmit: (e: FormEvent) => void;
}

const PostJobComp = ({
  handleChange,
  handleSelect,
  handleReset,
  handleSubmit,
}: PostJobCompProps) => {
  const { inputs, postJobLoading } = useSelector(
    (store: RootState) => store.postJobStore
  );

  const {
    position,
    company,
    jobType,
    jobLocation,
    jobDescription,
    jobRequirements,
    benefits,
    qualifications,
    interviewProcess,
    jobUrl,
    jobEmail,
    socialMedia: { whatsapp, telegram },
  } = inputs;

  return (
    <>
      {postJobLoading && (
        <Overlay>
          <Loader />
        </Overlay>
      )}
      <InputWrapper>
        <div className="role__one">
          <InputBox
            jobName="Position"
            typeName="text"
            inputName="position"
            inputValue={position}
            handleChange={handleChange}
          />
          <InputBox
            jobName="Company"
            typeName="text"
            inputName="company"
            inputValue={company}
            handleChange={handleChange}
          />
          <InputBox
            jobName="Job Location"
            typeName="text"
            inputName="jobLocation"
            inputValue={jobLocation}
            handleChange={handleChange}
          />
        </div>

        <TextArea
          name={"jobDescription"}
          value={jobDescription}
          placeholder={"Describe the company and/or job here"}
          label={"Description (optional)"}
          cols={12}
          rows={3}
          handleChange={handleChange}
        />
        <TextArea
          name={"jobRequirements"}
          value={jobRequirements}
          placeholder={"Add job requirements here"}
          label={"Job Requirements/About Role (optional)"}
          cols={12}
          rows={3}
          handleChange={handleChange}
        />
        <TextArea
          name={"benefits"}
          value={benefits}
          placeholder={"Add particular job benefits here"}
          label={"Job Benefits/Bonuses (optional)"}
          cols={12}
          rows={3}
          handleChange={handleChange}
        />
        <TextArea
          name={"qualifications"}
          value={qualifications}
          placeholder={"Add particular job qualifications here"}
          label={"Job Qualifications (optional)"}
          cols={12}
          rows={3}
          handleChange={handleChange}
        />
        <TextArea
          name={"interviewProcess"}
          value={interviewProcess}
          placeholder={
            "Add the process for applying and/or interview process here"
          }
          label={"Application/Interview Process (optional)"}
          cols={12}
          rows={3}
          handleChange={handleChange}
        />

        <div className="last__role">
          <SelectOption
            statusName="jobType"
            statusValue={jobType}
            selectName="Job Type"
            optionOne="Full-time (on-site)"
            optionTwo="Full-time (remote)"
            optionThree="Part-time (on-site)"
            optionFour="Part-time (remote)"
            optionFive="Internship (on-site)"
            optionSix="Internship (remote)"
            optionSeven="Contract (on-site)"
            optionEight="Contract (remote)"
            optionController="jobType"
            valueOne="full-time-onsite"
            valueTwo="full-time-remote"
            valueThree="part-time-onsite"
            valueFour="part-time-remote"
            valueFive="internship-onsite"
            valueSix="internship-remote"
            valueSeven="contract-onsite"
            valueEight="contract-remote"
            handleSelect={handleSelect}
          />
          <InputBox
            jobName="Url to apply (optional)"
            typeName="text"
            inputName="jobUrl"
            inputValue={jobUrl}
            placeholder="Add link to complete application if any"
            handleChange={handleChange}
          />
          <InputBox
            jobName="HR Email to apply (optional)"
            typeName="text"
            inputName="jobEmail"
            placeholder="Add HR email to send application if any"
            inputValue={jobEmail}
            handleChange={handleChange}
          />
          <InputBox
            jobName="Our WhatsApp platform(optional)"
            typeName="text"
            inputName="whatsapp"
            placeholder="Add your whatsapp link that people can join"
            inputValue={whatsapp}
            handleChange={handleChange}
          />
          <InputBox
            jobName="Our Telegram platform (optional)"
            typeName="text"
            inputName="telegram"
            placeholder="Add your telegram link that people can join"
            inputValue={telegram}
            handleChange={handleChange}
          />

          <ButtonWrapper>
            <Button
              button="Clear"
              type="reset"
              handleSubmit={handleReset}
              btnStyle={{
                cursor: `${postJobLoading ? "not-allowed" : ""}`,
              }}
            />
            <Button
              button="Submit"
              handleSubmit={handleSubmit}
              type="submit"
              allLoading={postJobLoading}
              allDisable={postJobLoading}
              btnStyle={{
                cursor: `${postJobLoading ? "not-allowed" : ""}`,
              }}
            />
          </ButtonWrapper>
        </div>
      </InputWrapper>
    </>
  );
};

export default PostJobComp;
